import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Header2 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <h2
        ref={ref}
        className={cn(
          'lg:text-2xl text-xl font-normal text-gray-900 leading-tight tracking-tight',
          className
        )}>
        {children}
      </h2>
    )
  }
)

Header2.displayName = 'Header2'

export default Header2
